import { SITE_URL } from '../resolveSEO';
import type { BreadcrumbItem } from '../types';

interface Input {
  url: string;
  breadcrumbs?: BreadcrumbItem[];
}

export const buildBreadcrumbList = ({ url, breadcrumbs }: Input) => {
  if (!breadcrumbs || breadcrumbs.length === 0) return null;
  return {
    '@type': 'BreadcrumbList',
    '@id': `${url}#breadcrumb`,
    itemListElement: breadcrumbs.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: `${SITE_URL}${item.path}`,
    })),
  };
};
